import { ref, reactive, computed, onMounted, watch } from 'vue'
import { defineStore } from 'pinia'

import { useCategory } from '@store/category'
import { useService } from '@store/service'
import { useStaff } from '@store/staff'
import { useSettings } from '@store/settings'

import { useRoute, useRouter } from 'vue-router'

import { textColor, progress, getPrice, timeZones, sortedDays, validationCheck, regex, toRGB } from '@utils'

export const useStaffItem = defineStore('staffItem', () => {
    const $category = useCategory()
    const $service = useService()
    const $staff = useStaff()
    const $settings = useSettings()
    const route = useRoute()
    const router = useRouter()


    const state = reactive({
        loading: true,
    })

    const staff = ref({
        display_name: '',
        meta: {
            color: '#2E90FA',
        },
        services: [],
        // status: '',
        working_hours: {},
        days_off: []
    })


    const resetStaff = () => {
        staff.value = {
            display_name: '',
            meta: {
                color: '#2E90FA',
            },
            services: [],
            // status: '',
            working_hours: {},
            days_off: []
        }
    }

    const staffId = computed(() => {
        return route.params.staffId
    })
    const isNew = computed(() => {
        return !staffId.value
    })


    const isProvider = computed(() => {
        return route.name == 'staff.provider'
    })

    const isStaffChanged = ref(false)

    watch(staff, (newVal, oldVal) => {
        isStaffChanged.value = true
    }, { deep: true })

    const mountStaffItem = async () => {
        setTimeout(() => {
            isStaffChanged.value = false
        }, 2000)
        await $staff.fetchData()
        await $service.fetchData()

        let isClone = route.query.clone_staff
        if (isClone) {
            // Loading.
            state.loading = true

            // Fetch Staff.
            staff.value = await $staff.fetchStaffs(route.query.clone_staff)
            staff.value.staff_id = null
            // Not loading.
            state.loading = false
            isStaffChanged.value = false
        }

        // if provider staff
        if (isProvider.value) {

            staff.value.meta.color = '#7F56D9'
            console.log($staff.getStaffs)
            let findProvider = $staff.getStaffs.find(s => s.meta.timezone)// change meta.timezone to meta.provider

            if (findProvider) {
                staff.value = findProvider
            }

            state.loading = false
            isStaffChanged.value = false
            return
        }

        // if new staff
        if (isNew.value) {
            if (!isClone) {
                const getRandomColor = () => {
                    const keys = Object.keys(prebook_admin.options.color_sets)
                    return keys[Math.floor(Math.random() * keys.length)]
                }

                staff.value.meta = { color: getRandomColor(), }

                sortedDays().forEach(day => {
                    staff.value.working_hours[day] = {
                        enabled: false,
                        hours: [],
                    }
                })
            }

            router.replace({
                query: {
                    ...route.query,
                    tab: 'profile',
                }
            })

            state.loading = false
            isStaffChanged.value = false
            return
        }

        // Loading.
        state.loading = true

        // Fetch Staff.
        staff.value = await $staff.fetchStaffs(staffId.value)

        if (!staff.value.meta.color) {
            staff.value.meta.color = '#2E90FA'
            await $staff.updateStaff(staff.value)
        }

        // Not loading.
        state.loading = false
        isStaffChanged.value = false
    }

    const submit = async (type, onboarding = false) => {
        // validation
        let { errors } = type !== 'draft' ? validationCheck([
            {
                condition: !staff.value.meta.first_name,
                message: `Please enter ${String($settings.labels.staff?.singular).toLowerCase()} first name`,
            },
            {
                condition: !staff.value.meta.last_name,
                message: `Please enter ${String($settings.labels.staff?.singular).toLowerCase()} last name`,
            },
            {
                condition: !staff.value.display_name,
                message: `Please enter ${String($settings.labels.staff?.singular).toLowerCase()} display name`,
            },
            {
                condition: !staff.value.meta.email,
                message: `Please enter ${String($settings.labels.staff?.singular).toLowerCase()} email`,
            },
            {
                condition: !regex.email.test(staff.value.meta.email),
                message: `Invalid ${String($settings.labels.staff?.singular).toLowerCase()} email format`,
            },
            {
                condition: !staff.value.meta.phone,
                message: `Please enter ${String($settings.labels.staff?.singular).toLowerCase()} phone`,
            },
            {
                condition: !regex.phone.test(staff.value.meta.phone),
                message: `Invalid ${String($settings.labels.staff?.singular).toLowerCase()} phone format`,
            },
        ]) : false

        if (errors) return state.saving = false

        let isArchived = staff.value.meta.status == 'archive'

        staff.value.meta.status = type

        console.log(staff.value)
        // return
        // after validation submit form 
        const response = await $staff.updateStaff(staff.value)
        // Log('RESPONSE', response)

        state.saving = false

        if (!response.success) return Toast.error(response.message)

        if (response.success && isNew.value) {
            // route to, no push
            if (!isProvider.value) {
                // router.push({
                //     name: 'staff.edit',
                //     params: {
                //         staffId: response.data.staff_id,
                //     },
                //     query: route.query,
                // })

                // back to list page [issue #82]
                router.push({ name: 'staff.list' })

                staff.value.staff_id = response.data.staff_id
            }

        }

        // multiple success message
        if (response.success) {
            if (isArchived) Toast.success(`${String($settings.labels.staff?.singular)} restored and published successfully`)
            else if (type === 'draft') Toast.success(`${String($settings.labels.staff?.singular)} draft saved successfully`)
            else if (type === 'archive') Toast.success(`${String($settings.labels.staff?.singular)} archived successfully`)
            else if (isNew.value) {
                Toast.success(`${String($settings.labels.staff?.singular)} added successfully`)
                // back to list page [issue #82]
                router.push({ name: 'staff.list' })
            }
            else {
                Toast.success(`${String($settings.labels.staff?.singular)} details updated successfully`)
                // back to list page [issue #82]
                router.push({ name: 'staff.list' })
            }
        }

        if (onboarding) {
            resetStaff()
            router.push({ name: 'dashboard' })
        }

    }
    watch(() => staff, () => {
        console.log('staff item', staff.value)
    }, { deep: true })

    return {
        staff, isNew, resetStaff, submit, mountStaffItem, state, staffId, isProvider,isStaffChanged
    }
})